import type { Company } from "@/types/contentful/company.d";
import { Box, Link, Typography } from "@mui/material";
import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { Locale,routing } from "@/i18n/routing";

interface PhoneNumberProps {
    company?: Company;
    locale: Locale;
}

export default function PhoneNumber({company, locale}: PhoneNumberProps) {
    const phoneNumber = company?.phoneNumber || "";
    
    const currentLocale = locale || routing.defaultLocale;
    const phoneNumberTestID = `phone-number-${currentLocale}`;

    


    return (
        <Link href={`tel:${phoneNumber}`} sx={{ display: "flex", color: "var(--isagent-text-color)", textDecoration: "none"}}>
            <Box sx={{ py:1 }}>                    
                <PhoneIcon sx={{ width: "23px", height: "23px", color: "var(--isagent-text-color)", transform: "scaleX(-1)" }} />
            </Box>
            <Box sx={{ pt: .5 }}>
                <Typography sx={{ fontSize: "1.8rem", fontWeight: "600", lineHeight: 1.5, pl: 1 }} data-testid={phoneNumberTestID}>
                    {phoneNumber}
                </Typography>
                <Typography sx={{ fontSize: "9px", wordSpacing: "0px", fontWeight: "700", whiteSpace: "nowrap", pl: 1 }}>
                    or call your travel advisor
                </Typography>
            </Box>
        </Link>
    );
}